import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default class SearchForm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            status: '',
            first_last_name: '',
            nickname: '',
            email: '',
            staff_id: '',
            ticket_id: '',
            pref: '',
            city: '',
            cities:[],
            prefs: [],
            helper_category_id:'',
            helper_sub_category_id: '',
            helper_categories: [],
            helper_sub_categories:[],
            page: 1
        }
        // this.handleChangeWorkStartDateCreated = this.handleChangeWorkStartDateCreated.bind(this);
        // this.handleChangeWorkEndDateCreated = this.handleChangeWorkEndDateCreated.bind(this);
        this.handleFieldChange = this.handleFieldChange.bind(this);
        this.handleSearchData = this.handleSearchData.bind(this);
        this.resetInputField = this.resetInputField.bind(this);
    }

    /**
     * Init data
     */
    componentWillMount() {
        axios.get('/api/cities').then(response => {
            this.setState({
                cities: response.data
            });
        })
        axios.get('/api/prefs').then(response => {
            this.setState({
                prefs: response.data
            });
        })
        axios.get('/api/helper-categories').then(response => {
            this.setState({
                helper_categories: response.data
            });
        })
        axios.get('/api/helper-sub-categories').then(response => {
            this.setState({
                helper_sub_categories: response.data
            });
        })
    }

    /**
     * Call search data by text
     */
    handleSearchData() {
        const searchForm = {
            status: this.state.status,
            first_last_name: this.state.first_last_name,
            nickname: this.state.nickname,
            email: this.state.email,
            staff_id: this.state.staff_id,
            ticket_id: this.state.ticket_id,
            pref: this.state.pref,
            city: this.state.city,
            helper_category_id: this.state.helper_category_id,
            helper_sub_category_id: this.state.helper_sub_category_id,
            page: 1
        };
        if (typeof this.props.onSearch === 'function') {
            this.props.onSearch(searchForm);
        }
    }

    // /**
    //  * Process change date create at
    //  */
    // handleChangeWorkStartDateCreated(date) {
    //     this.setState({
    //         work_start_date: date,
    //     });
    // }

    // /**
    //  * Process change date create at
    //  */
    // handleChangeWorkEndDateCreated(date) {
    //     this.setState({
    //         work_end_date: date,
    //     });
    // }

    /**
     * Process field change
     */
    handleFieldChange(event) {
        if (event.target.name === 'helper_category_id') {
            this.setState({
                'helper_sub_category_id': ''
            })
        }
        if (event.target.name === 'pref') {
            this.setState({
                'city': ''
            })
        }

        this.setState({
            [event.target.name]: event.target.value
        })
    }

    /**
     * Clear data input field
     */
    resetInputField() {
        this.setState({
            status: '',
            first_last_name: '',
            nickname: '',
            email: '',
            staff_id: '',
            ticket_id: '',
            pref: '',
            city: '',
            helper_category_id:'',
            helper_sub_category_id:'',
        });
    }

    render() {
        return(
            <div className="collapse multi-collapse" id="search_order">
                <div className="card mt-3">
                    <div className="card-header">チケットを検索する条件</div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-sm-3">
                                    <div className="form-group">
                                        <label className="form-label" htmlFor="">ステータス</label>
                                        <select className="form-control" name="status" value={this.state.status} onChange={this.handleFieldChange}>
                                            <option value="all">すべて</option>
                                            <option value="1">公開</option>
                                            <option value="0">非公開</option>
                                        </select>
                                    </div>
                                </div>
                                {/* <div className="col-sm-3">
                                    <div className="form-group">
                                        <label className="form-label" htmlFor="">就業日(開始)</label>
                                        <div className="input-group">
                                            <DatePicker
                                                locale="ja-JP"
                                                className="form-control form_datepicker"
                                                dateFormat="LL"
                                                timeCaption="時間"
                                                selected={this.state.work_start_date}
                                                onChange={this.handleChangeWorkStartDateCreated}
                                                placeholderText="就業日(開始)"
                                                disabledKeyboardNavigation
                                            />
                                            <div className="input-group-append">
                                                <button className="btn btn-outline-secondary" type="button" id="form-calendar"><i className="material-icons">calendar_today</i></button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-3">
                                    <div className="form-group">
                                        <label className="form-label" htmlFor="">就業日(終了)</label>
                                        <div className="input-group">
                                            <DatePicker
                                                locale="ja-JP"
                                                className="form-control form_datepicker"
                                                dateFormat="LL"
                                                timeCaption="時間"
                                                selected={this.state.work_end_date}
                                                onChange={this.handleChangeWorkEndDateCreated}
                                                placeholderText="就業日(終了)"
                                                disabledKeyboardNavigation
                                            />
                                            <div className="input-group-append">
                                                <button className="btn btn-outline-secondary" type="button" id="form-calendar"><i className="material-icons">calendar_today</i></button>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                                <div className="col-sm-3">
                                    <div className="form-group">
                                        <label className="form-label" htmlFor="">ワーカー名</label>
                                        <input type="text" name="first_last_name" onChange={this.handleFieldChange} value={this.state.first_last_name} className="form-control" placeholder="ワーカー名"/>
                                    </div>
                                </div>
                                <div className="col-sm-3">
                                    <div className="form-group">
                                        <label className="form-label" htmlFor="">ニックネーム</label>
                                        <input type="text" name="nickname" onChange={this.handleFieldChange} value={this.state.nickname} className="form-control" placeholder="ニックネーム"/>
                                    </div>
                                </div>
                                <div className="col-sm-3">
                                    <div className="form-group">
                                        <label className="form-label" htmlFor="">メールアドレス</label>
                                        <input type="text" className="form-control" name="email" onChange={this.handleFieldChange} value={this.state.email} placeholder="メールアドレス"/>
                                    </div>
                                </div>
                                <div className="col-sm-3">
                                    <div className="form-group">
                                        <label className="form-label" htmlFor="">ワーカーID</label>
                                        <input type="text" name="staff_id" onChange={this.handleFieldChange} value={this.state.staff_id} className="form-control" placeholder="ワーカーID"/>
                                    </div>
                                </div>
                                <div className="col-sm-3">
                                    <div className="form-group">
                                        <label className="form-label" htmlFor="">居住地(都道府県)</label>
                                        <select onChange={this.handleFieldChange} name="pref" value={this.state.pref ? this.state.pref : ''} className="form-control" >
                                            <option value="">すべて</option>
                                            {this.state.prefs.map((dataRow, i) => {
                                                    return <option key={i} value={dataRow.id}>{dataRow.name}</option>;
                                            })}
                                        </select>
                                    </div>
                                </div>
                                <div className="col-sm-3">
                                    <div className="form-group">
                                        <label className="form-label" htmlFor="">居住地(市区町村)</label>
                                        <select onChange={this.handleFieldChange} name="city" value={this.state.city ? this.state.city : ''} className="form-control" >
                                            <option value="">すべて</option>
                                            {this.state.cities.filter(city => city.pref_id == this.state.pref).map((dataRow, i) => {
                                                    return <option key={i} value={dataRow.id}>{dataRow.name}</option>;
                                            })}
                                        </select>
                                    </div>
                                </div>
                                <div className="col-sm-3">
                                    <div className="form-group">
                                        <label className="form-label" htmlFor="">大カテゴリ</label>
                                        <select onChange={this.handleFieldChange} name="helper_category_id" value={this.state.helper_category_id ? this.state.helper_category_id : ''} className="form-control" >
                                            <option value="">すべて</option>
                                            {this.state.helper_categories.map((dataRow, i) => {
                                                    return <option key={i} value={dataRow.id}>{dataRow.category_name}</option>;
                                            })}
                                        </select>
                                    </div>
                                </div>
                                <div className="col-sm-3">
                                    <div className="form-group">
                                        <label className="form-label" htmlFor="">小カテゴリ</label>
                                        <select onChange={this.handleFieldChange} name="helper_sub_category_id" value={this.state.helper_sub_category_id ? this.state.helper_sub_category_id : ''} className="form-control" >
                                            <option value="">すべて</option>
                                            {this.state.helper_sub_categories.filter(helper_sub_category => helper_sub_category.parent_id == this.state.helper_category_id).map((dataRow, i) => {
                                                    return <option key={i} value={dataRow.id}>{dataRow.category_name}</option>;
                                            })}
                                        </select>
                                    </div>
                                </div>
                                <div className="col-sm-3">
                                    <div className="form-group">
                                        <label className="form-label" htmlFor="">チケットID</label>
                                        <input type="text" name="ticket_id" onChange={this.handleFieldChange} value={this.state.ticket_id} className="form-control" placeholder="チケットID"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card-footer text-center">
                            <button type="reset" onClick={this.resetInputField} className="btn btn-light">リセット</button>
                            <button type="submit" onClick={this.handleSearchData} className="btn btn-secondary">検索する</button>
                        </div>
                </div>
            </div>
        );
    }
}
